<header class="detail-header card" [attr.data-testid]="testId || null">
    <div class="detail-header-top">
        <div class="detail-header-titles">
            <h1 class="detail-header-title" data-testid="detail-header-title">
                {{ model.title }}
            </h1>
            <span *ngIf="model.status as s"
                  [class]="statusBadgeClass(s.tone)"
                  data-testid="detail-header-status">
                {{ s.label }}
            </span>
            <p *ngIf="model.subtitle" class="detail-header-subtitle">
                {{ model.subtitle }}
            </p>
        </div>

        <app-detail-action-bar
            *ngIf="model.actions?.length"
            class="detail-header-actions"
            [actions]="model.actions || []"
            (action)="onAction($event)">
        </app-detail-action-bar>
    </div>

    <div *ngIf="model.chips?.length" class="detail-header-chips">
        <span *ngFor="let chip of model.chips" class="detail-header-chip"
              [title]="chip.tooltip || ''">
            <i *ngIf="chip.icon" class="fa" [ngClass]="chip.icon"></i>
            <ng-container *ngIf="chip.routerLink as link; else plain">
                <a [routerLink]="link" class="detail-header-chip-link">
                    <strong>{{ chip.label }}</strong>
                    <span *ngIf="chip.value != null" class="detail-header-chip-value">{{ chip.value }}</span>
                </a>
            </ng-container>
            <ng-template #plain>
                <strong>{{ chip.label }}</strong>
                <span *ngIf="chip.value != null" class="detail-header-chip-value">{{ chip.value }}</span>
            </ng-template>
        </span>
    </div>
</header>
